/**
 * Mobile-only autoplay for announcement bar USPs (looped).
 */
(function () {
  const MQ = '(max-width: 749px)';

  function initRoot(root) {
    const scroller = root.querySelector('[data-topbar-usp-scroll]');
    const slides = scroller ? Array.from(scroller.querySelectorAll('[data-topbar-usp-slide]')) : [];
    if (!scroller || slides.length < 2) return;

    if (typeof root._topbarUspCleanup === 'function') {
      root._topbarUspCleanup();
      root._topbarUspCleanup = null;
    }

    const autoplayMs = Math.max(3000, Number(root.dataset.autoplaySeconds || '5') * 1000);
    let index = 0;
    let intervalId = null;
    let resumeTimeoutId = null;

    const mq = window.matchMedia(MQ);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function scrollToIndex(i) {
      const el = slides[i];
      if (!el) return;
      scroller.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
    }

    function step() {
      index = (index + 1) % slides.length;
      scrollToIndex(index);
    }

    function clearTimers() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      if (resumeTimeoutId) {
        clearTimeout(resumeTimeoutId);
        resumeTimeoutId = null;
      }
    }

    function startAutoplay() {
      clearTimers();
      if (!mq.matches || reduceMotion.matches) {
        scroller.scrollLeft = 0;
        index = 0;
        return;
      }
      intervalId = window.setInterval(step, autoplayMs);
    }

    function pauseAndResumeLater() {
      clearTimers();
      if (!mq.matches) return;
      resumeTimeoutId = window.setTimeout(startAutoplay, autoplayMs * 2);
    }

    const onMqChange = () => startAutoplay();
    mq.addEventListener('change', onMqChange);
    reduceMotion.addEventListener('change', onMqChange);

    const onVisibility = () => {
      if (document.hidden) {
        clearTimers();
      } else {
        startAutoplay();
      }
    };
    document.addEventListener('visibilitychange', onVisibility);

    const onPointerDown = () => pauseAndResumeLater();
    scroller.addEventListener('pointerdown', onPointerDown, { passive: true });

    root._topbarUspCleanup = () => {
      clearTimers();
      mq.removeEventListener('change', onMqChange);
      reduceMotion.removeEventListener('change', onMqChange);
      document.removeEventListener('visibilitychange', onVisibility);
      scroller.removeEventListener('pointerdown', onPointerDown);
    };

    startAutoplay();
  }

  function boot() {
    document.querySelectorAll('[data-topbar-usp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-topbar-usp-root]').forEach(initRoot);
  });
})();
